"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.3,4.3c0.4,0.5,0.8,1.1,1.2,1.6C22.1,5.3,21.7,4.8,21.3,4.3z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.4,5.9c0.3,0.6,0.6,1.2,0.9,1.8C23.1,7.1,22.8,6.5,22.4,5.9z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.5,3.5L3.5,3.5c0.3-0.3,0.6-0.6,0.9-0.8C4.1,2.9,3.8,3.2,3.5,3.5z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.5,2.7C6,1.4,7.9,0.6,9.8,0.2C7.9,0.6,6,1.4,4.5,2.7z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23,10.4c-0.2-1.3-0.6-2.5-1.3-3.7C22.4,7.8,22.8,9.1,23,10.4z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "10.4,24 11.3,23.1 10.4,24",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.1,11.4L23.1,11.4c0-0.3-0.1-0.6-0.1-1C23,10.7,23.1,11,23.1,11.4z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.8,0.2C10.5,0.1,11.3,0,12.1,0C11.3,0,10.5,0.1,9.8,0.2z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11,1C11.7,1,12.4,1,13.1,1C12.4,1,11.7,1,11,1z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.1,1c2.5,0.2,4.9,1.3,6.8,3.2c0.7,0.7,1.4,1.6,1.8,2.4c-0.5-0.9-1.1-1.7-1.8-2.4C18,2.3,15.6,1.3,13.1,1z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.5,22.5c-1.6-0.5-3-1.4-4.2-2.7c-1.1-1.1-1.9-2.3-2.4-3.7c0.5,1.3,1.3,2.6,2.4,3.7 C5.5,21.1,6.9,22,8.5,22.5z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.2,14.2c0.1,0.7,0.3,1.4,0.6,2.1C1.5,15.5,1.3,14.9,1.2,14.2z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.8,6c0.4-0.6,0.9-1.2,1.4-1.7l0,0C3.7,4.8,3.2,5.3,2.8,6z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.1,0c-0.8,0-1.5,0.1-2.3,0.2C7.9,0.6,6,1.4,4.5,2.7C4.1,2.9,3.8,3.2,3.5,3.5C2.7,4.4,1.9,5.4,1.4,6.4 C1,7.1,0.7,7.9,0.5,8.6C0.2,9.7,0,10.9,0,12c0,0.4,0,0.8,0.1,1.2c0.1,0.8,0.2,1.5,0.4,2.3c0.2,0.7,0.5,1.5,0.9,2.2 c0.5,1.1,1.3,2,2.1,2.9c0.5,0.5,1,0.9,1.5,1.3c0.8,0.6,1.7,1,2.6,1.4c0.3,0.1,0.6,0.2,0.9,0.3c0.6,0.2,1.2,0.3,1.9,0.4l0.9-0.9 c-1-0.1-1.9-0.3-2.9-0.6c-1.6-0.5-3-1.4-4.2-2.7c-1.1-1.1-1.9-2.3-2.4-3.7c-0.3-0.7-0.5-1.4-0.6-2.1c-0.5-2.8,0-5.8,1.6-8.2 c0.4-0.6,0.9-1.2,1.4-1.7l0,0l0,0c0.5-0.5,1.1-1,1.7-1.4c0.3-0.2,0.6-0.4,0.9-0.6c0.6-0.3,1.3-0.6,2-0.8C9.6,1.2,10.3,1.1,11,1 C11.7,1,12.4,1,13.1,1c2.5,0.2,4.9,1.3,6.8,3.2c0.7,0.7,1.4,1.6,1.8,2.4c0.6,1.2,1.1,2.4,1.3,3.7c0,0.3,0.1,0.6,0.1,1l0.9-0.9 c-0.1-0.9-0.4-1.9-0.7-2.8c-0.2-0.6-0.5-1.2-0.9-1.8c-0.3-0.6-0.7-1.1-1.2-1.6c-0.2-0.3-0.4-0.5-0.7-0.8C18.2,1.2,15.2,0,12.1,0z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.9,1.4c-0.7,0.2-1.4,0.5-2,0.8C7.6,1.9,8.2,1.6,8.9,1.4z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "23.1,11.4 24,10.4 23.1,11.4",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,12c0-1.2,0.2-2.3,0.5-3.4C0.2,9.7,0,10.9,0,12z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.5,3.5C2.7,4.4,1.9,5.4,1.4,6.4C1.9,5.4,2.7,4.4,3.5,3.5L3.5,3.5z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.5,8.6C0.7,7.9,1,7.1,1.4,6.4C1,7.1,0.7,7.9,0.5,8.6z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.2,4.2c0.5-0.5,1.1-1,1.7-1.4C5.4,3.2,4.8,3.7,4.2,4.2L4.2,4.2z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.6,23.3c-0.9-0.4-1.8-0.8-2.6-1.4C5.9,22.5,6.7,22.9,7.6,23.3z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.4,24L10.4,24c-0.6-0.1-1.3-0.2-1.9-0.4C9.2,23.8,9.8,23.9,10.4,24z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.4,17.7c-0.4-0.7-0.7-1.4-0.9-2.2C0.7,16.2,1,16.9,1.4,17.7z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.5,15.5c-0.2-0.7-0.4-1.5-0.4-2.3C0.1,14,0.3,14.7,0.5,15.5z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.9,4.9C1,8.8,1,15.2,4.9,19.2c1.7,1.7,4,2.8,6.5,2.9l0.9,0.1l9.8-9.8l-0.1-0.9c-0.2-2.4-1.2-4.7-2.9-6.5 C15.3,1,8.9,1,4.9,4.9z M15.3,15.3c-1.8,1.8-4.7,1.8-6.5,0s-1.8-4.7,0-6.5c1.8-1.8,4.7-1.8,6.5,0S17.1,13.5,15.3,15.3z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.3,9.3c-1.5,1.5-1.5,4,0,5.6c1.5,1.5,4,1.5,5.6,0c1.5-1.5,1.5-4,0-5.6C13.3,7.7,10.8,7.7,9.3,9.3z",
    fill: "#004864"
  })))));
};

exports["default"] = _default;